const about = [
    {
        id: 1,
        paragraph: "For most of us, the Internet plays a pivotal role in our realities."
    },
    {
        id: 2,
        paragraph: "The network is ever growing and changing due to the constant influx of images and stories. It facilitates endless connectedness and provides direction when we are lost. It hosts forums for sharing both cute pictures of puppies alongside a myriad of hate and unapologetic offensiveness."
    },
    {
        id: 3,
        paragraph: "It has become close to impossible to go through life without being in some way connected to the Web."
    },
    {
        id: 4,
        paragraph: "In 2021, Nathan Gotlib initiated the research project <i>Call Me By Your Meme</i>. In it he has emulated the Web’s format of forum conversations, information sharing, and image sampling and decontextualisation."
    },
    {
        id: 5,
        paragraph: "He questions what happens to a concept such as “ownership” when everything is just one swipe away, and how ownership can exist in a world ripe with NFT’s and AI generated artwork."
    },
    {
        id: 6,
        paragraph: "By using the iconic status of (in)famous memes, like <i>ALL YOUR BASE</i>, <i>This is Fine</i> and <i>Pepe Frog</i>, Gotlib created a series of prints, which he distributed among artists he met through the Frans Masereel Centrum, M HKA, or his print studio at the Blikfabriek."
    },
    {
        id: 7,
        paragraph: "24 artists got involved and were given complete freedom in reworking the original prints."
    },
    {
        id: 8,
        paragraph: "<i>Call Me By Your Meme</i> is an ongoing project with a growing collection of iconic web-based images, reimagined through the creative practice of different artists."
    },
    {
        id: 9,
        paragraph: "The project will continue to question the role of the artist, challenge the idea of intellectual property and seek to connect the real world to the ethereal world of the Internet."
    }
]


export default about;